function isSelectElement(element: unknown): element is HTMLSelectElement {
    return element instanceof HTMLSelectElement;
}

export default isSelectElement;
